import React, { useRef } from "react";
import { debounce } from "throttle-debounce";
import {
    ControlLabel,
    FormControl,
    FormGroup,
    Glyphicon,
    Checkbox,
    Button,
    Row,
    Col,
} from "react-bootstrap";
import Select from "react-select";
import { useModuleSettingsContext } from "../../../../context";
import PanelTabWrapper from "../PanelTabWrapper";
import FormControlLanguage from "../../../UI/FormControlLanguage";
import { fontSizeOptions, playerSizeOptions } from "./lib";

const Page = () => {
    const {
        modulePage,
        onSavePage,
        onSavePageFile,
        setPropertyPage,
        isSaving,
    } = useModuleSettingsContext();
    const imageInputRef = useRef(null);

    const handleChangeColor = debounce(500, (key, value) => {
        const color = value.replace('#', '');
        onSavePage({[key]: color});
    });

    return (
        <PanelTabWrapper title="Страница">
            <>
                <ControlLabel>Ширина плеера</ControlLabel>
                <Select
                    value={playerSizeOptions.find(({ value }) => modulePage.playerSize === value) || positionOptions[0]}
                    onChange={({ value }) => onSavePage({playerSize: value})}
                    options={playerSizeOptions}
                    isDisabled={isSaving}
                />
                <Row style={{marginTop: 10}}>
                    <Col xs={6}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 5}}>
                            <Checkbox
                                checked={modulePage.textEnabled}
                                onChange={(e) => onSavePage({textEnabled: e.target.checked})}
                            ><ControlLabel>Текст</ControlLabel></Checkbox>
                            <FormGroup style={{display: 'flex', alignItems: 'center', marginBottom: 0}}>
                                <input
                                    type="color"
                                    value={`#${modulePage.textColor}`}
                                    onChange={(e) => handleChangeColor('textColor', e.target.value)}
                                />
                            </FormGroup>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 5, marginBottom: 5}}>
                            <Checkbox
                                checked={modulePage.backgroundEnabled}
                                onChange={(e) => onSavePage({backgroundEnabled: e.target.checked})}
                            ><ControlLabel>Фон</ControlLabel></Checkbox>
                            <FormGroup style={{display: 'flex', alignItems: 'center', marginBottom: 0}}>
                                <input
                                    type="color"
                                    value={`#${modulePage.backgroundColor}`}
                                    onChange={(e) => handleChangeColor('backgroundColor', e.target.value)}
                                />
                            </FormGroup>
                        </div>
                        <FormGroup style={{ zIndex: 10, position: 'relative', display: 'flex', alignItems: 'center', gap: 10 }}>
                            <ControlLabel>Шрифт</ControlLabel>
                            <Select
                                value={fontSizeOptions.find(({ value }) => modulePage.fontSize === value) || fontSizeOptions[0]}
                                onChange={({ value }) => onSavePage({fontSize: value})}
                                options={fontSizeOptions}
                                isDisabled={isSaving}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>{modulePage.backgroundUrl ? "Изменить" : "Добавить"} Фон</ControlLabel>
                            {modulePage.backgroundUrl && <div><img src={modulePage.backgroundUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
                            <div>
                                <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                            </div>
                            <FormControl
                                type="file"
                                onChange={(e) => onSavePageFile('backgroundImage', e.target.files[0] || null)}
                                inputRef={ref => imageInputRef.current = ref}
                                style={{ display: 'none' }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup>
                    <ControlLabel>Текст сверху</ControlLabel>
                    <FormControlLanguage
                        type="textarea"
                        values={{
                            ru: modulePage.header_ru,
                            en: modulePage.header_en,
                        }}
                        onChange={{
                            ru: (e) => setPropertyPage('header_ru', e.target.value),
                            en: (e) => setPropertyPage('header_en', e.target.value),
                        }}
                        onBlur={() => onSavePage({ header_ru: modulePage.header_ru, header_en: modulePage.header_en })}
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Текст снизу</ControlLabel>
                    <FormControlLanguage
                        type="textarea"
                        values={{
                            ru: modulePage.footer_ru,
                            en: modulePage.footer_en,
                        }}
                        onChange={{
                            ru: (e) => setPropertyPage('footer_ru', e.target.value),
                            en: (e) => setPropertyPage('footer_en', e.target.value),
                        }}
                        onBlur={() => onSavePage({ footer_ru: modulePage.footer_ru, footer_en: modulePage.footer_en })}
                    />
                </FormGroup>
            </>
        </PanelTabWrapper>
    );
};

export default Page;